import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCDBalList, resetCDBalList } from "../store";
import { RequiredRule, EmailRule, CustomRule } from "devextreme-react/form";
import "devextreme/dist/css/dx.light.css";
import { useNavigate, useLocation } from "react-router-dom";
import CdAddEdit from "../../../../../component/popups/cd_add_edit";
import DataGrid, {
  Export,
  Button,
  Column,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";

import { getLocalStorageItem, onExporting } from "../../../../../utils";
import moment from "moment";
import BulkUpload from "../../../../../component/bulk_upload";
import Loader from '../../../../../component/page_loader';

const CdBalList = () => {
  const [viewCdBalList, setViewCdBalList] = useState();
  const [viewCdDetails, setViewCdDetails] = useState();
  const [uploadBulk, setUploadBulk] = useState(false);
  const [cdAddEdit, setCDAddEdit] = useState(false);
  const [dataCd, setDataCd] = useState(false);
  const [role, setRole] = useState();
  const [isLoader, setIsLoader] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { CDBalList } = useSelector(state => ({
    ...state.listStore,
  }));

  useEffect(() => {
    setRole(getLocalStorageItem("next"));
    dispatch(actionCDBalList());
  }, []);

  useEffect(() => {
    dispatch(resetCDBalList());
    if (CDBalList != null) {
      if (CDBalList.status == true) {
        setIsLoader(false);
        setViewCdBalList(CDBalList.data.statement);
        setViewCdDetails(CDBalList.data);
      }
    }
  });

  const renderDateCell = date => {
    const formattedDate = moment(date).isValid()
      ? moment(date).format("DD-MMM-YYYY")
      : "-";
    return <span>{formattedDate}</span>;
  };

  const renderAmountFixed = data => {
    const amountFormat = data ? Number(data)?.toFixed(2) : "-";
    return amountFormat;
  };

  const renderAction = data => (
    <button
      className={`btn btn-sm btn-primary cursor-pointer w-80`}
      onClick={() => {
        if (data) {
          setCDAddEdit(true);
          setDataCd(data);
        }
      }}
    >
      Edit
    </button>
  );

  const renderZones = zones => {
    if (!zones) {
      return "-"; //  if policy details is available but emp zone is not
    }
    const temp = zones.reduce((totalArr, zone) => {
      totalArr.push(zone.name);
      return totalArr;
    }, []);
    if (temp.length === 0) {
      return "-"; // if policy detail is not available
    }
    return temp.join(", ");
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-2 mt-6">
        <h5 className="mb-0">CD Balance List</h5>
        <div>
          {role == "copsdashboard" && (
            <>
              <button
                className={`btn btn-sm btn-primary cursor-pointer me-2`}
                onClick={() => {
                  setDataCd(null);
                  setCDAddEdit(true);
                }}
              >
                Add
              </button>
              <button
                className={`btn btn-sm btn-primary cursor-pointer`}
                onClick={() => {
                  setUploadBulk(true);
                }}
              >
                Add Bulk
              </button>
            </>
          )}
        </div>
      </div>

      <div class="card mt-3">
        <div class="card-body">
          <div class="row">
            <div className="col-md-6">
              <div className="">
                <p className="mb-0">Total Deposit</p>
                <p className="fw-bold">
                  {Number(viewCdDetails?.total_credit)?.toFixed(2)}
                </p>
              </div>
              <div className="">
                <p className="mb-0">Gross Premium Utilised </p>
                <p className="fw-bold">
                  {Number(viewCdDetails?.total_premium_debit)?.toFixed(2)}
                </p>
              </div>
              <div className="">
                <p className="mb-0">Endorsement Gross Premium</p>
                <p className="fw-bold">
                  {Number(viewCdDetails?.total_endorsement_debit)?.toFixed(2)}
                </p>
              </div>
              <div className="">
                <p className="mb-0">Current Balance</p>
                <p className="fw-bold">
                  {Number(viewCdDetails?.current_balance)?.toFixed(2)}
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="">
                <p className="mb-0">Transaction Count </p>
                <p className="fw-bold">{viewCdDetails?.total_transaction}</p>
              </div>
              <div className="">
                <p className="mb-0">Net Premium Utilised</p>
                <p className="fw-bold">
                  {Number(viewCdDetails?.total_net_premium_debit)?.toFixed(2)}
                </p>
              </div>
              <div className="">
                <p className="mb-0">Endorsement Net Premium</p>
                <p className="fw-bold">
                  {Number(viewCdDetails?.total_net_endorsement_debit)?.toFixed(2)}
                </p>
              </div>

              <div className="">
                <p className="mb-0">Minimum Balance</p>
                <p className="fw-bold">
                  {Number(viewCdDetails?.minimum_balance)?.toFixed(2)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoader === true ? (
        <Loader />
      ) : (
        <div className="row pb-5 justify-content-center">
          <div className="col-12 mt-1">
            <div className="card border mt-3 mb-5">
              <div className="card-body" id="data-grid-demo">
                <DataGrid
                  id="claim_list"
                  dataSource={viewCdBalList}
                  columnMinWidth={100}
                  showBorders={true}
                  filterSyncEnabled={false}
                  allowColumnResizing={true}
                  onExporting={onExporting}
                >
                  <FilterRow visible={true} />
                  <HeaderFilter visible={true} />
                  <SearchPanel visible={true} />
                  {role == "copsdashboard" && (
                    <Column
                      dataField="action"
                      caption="Action"
                      cellRender={({ data }) => renderAction(data)}
                    />
                  )}
                  <Column
                    dataField="index"
                    caption="S.No"
                    dataType="number"
                    cellRender={rowData => {
                      return rowData?.rowIndex != null
                        ? Number(rowData?.rowIndex + 1)
                        : "-";
                    }}
                  />
                  <Column dataField="type" caption="Type" />
                  <Column
                    dataField="policyDetail.created_at"
                    caption="Data Received Date"
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />
                  <Column
                    dataField="payment_date"
                    caption="Date of ins / Del"
                    dataType="date"
                    cellRender={({ value }) => renderDateCell(value)}
                  />
                  {/* <Column
                  dataField="description"
                  caption="Transaction Description (Particulars)"
                /> */}
                  <Column
                    dataField="type"
                    caption="Transaction Type "
                  ></Column>
                  <Column
                    dataField="credit"
                    caption="Credit"
                    dataType="number"
                    cellRender={({ value }) => renderAmountFixed(value)}
                  />
                  <Column
                    dataField="debit"
                    caption="Debit"
                    dataType="number"
                    cellRender={({ value }) => renderAmountFixed(value)}
                  />
                  <Column
                    dataField="balance"
                    caption="Balance"
                    dataType="number"
                    cellRender={({ value }) => renderAmountFixed(value)}
                  />

                  <Column
                    dataField="userDetail.full_name"
                    caption="Employee Name"
                    cellRender={({ data }) => (data?.userDetail?.full_name ? data?.userDetail?.full_name : "-")}
                  />
                  <Column
                    dataField="userDetail.userCity.cityState.stateZone.name"
                    caption="Employee Zone"
                    cellRender={({ data }) => (data?.userDetail?.userCity?.cityState?.stateZone?.name ? data.userDetail?.userCity?.cityState?.stateZone?.name : "-")}
                  />
                  <Column dataField="policyDetail.policy_no"
                    caption="Policy Number"
                    cellRender={({ data }) => (data?.policyDetail?.policy_no ? data.policyDetail?.policy_no : "-")} />

                  <Column
                    dataField="endorsementDetail.endorsement_no"
                    caption="Endorsement Number "
                    cellRender={({ data }) => (data?.endorsementDetail?.endorsement_no ? data.endorsementDetail?.endorsement_no : "-")}
                  />
                  <Column
                    dataField="endorsementDetail.type"
                    caption="Endorsement Type"
                    cellRender={({ data }) => (data?.endorsementDetail?.type ? data?.endorsementDetail?.type : "-")}
                  ></Column>
                  <Column dataField="remark" caption="Remarks" />
                  <Export enabled={true} />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      )}
      <BulkUpload
        show={uploadBulk}
        module="cd"
        dynamic_url="importcds"
        handleUpdateList={() => {
          setUploadBulk(false);
          dispatch(actionCDBalList());
        }}
      />
      <CdAddEdit
        show={cdAddEdit}
        dataCd={dataCd}
        handleClose={() => {
          setCDAddEdit(false);
          dispatch(actionCDBalList());
        }}
      />
    </>
  );
};

export default CdBalList;
